import { FeaturedProject } from "config"

export const getArtBlocksPreviewImage = (
  chainId: number,
  contractAddress: string,
  tokenId: string,
) =>
  `https://media-proxy.artblocks.io/${chainId}/${contractAddress.toLowerCase()}/${tokenId}.png`

export const getFeaturedProjectPreviewImage = (project: FeaturedProject) =>
  getArtBlocksPreviewImage(project.chainId, project.contractAddress, project.sampleTokenId)

export const getYoutubeThumbnailUrl = (youtubeId?: string) =>
  youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg` : undefined
